/* V12 route and asset adapter. Native Shopify owns purchasing. */
(() => {
  'use strict';
  if (window.HGRoute && window.HGMarkup) return;
  const routes = Object.freeze({"home":"/","index":"/","shop":"/collections/all","story":"/pages/about-hidden-grounds","locations":"/pages/locations","contact":"/pages/contact","careers":"/pages/careers","cafe":"/pages/cafe","order":"/pages/order-ahead","chai":"/pages/chai","coffee":"/pages/coffee","gifts":"/pages/gifts","journal":"/pages/brewing-guides","subscriptions":"/pages/coffee-subscriptions","catering":"/pages/catering","events":"/pages/events","company":"/pages/company-partnerships","help":"/pages/help","privacy":"/pages/site-information","checkout":"/pages/ordering-options","thank-you":"/pages/order-help"});
  const officialHosts = new Set(['thehiddengrounds.com','www.thehiddengrounds.com',
    'hidden-grounds-coffee-roasters.myshopify.com']);
  const base = () => window.location?.href || 'https://thehiddengrounds.com/';
  const escapeAttribute = value => String(value).replace(/[&<>"']/g, character =>
    ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[character]));

  window.HGAsset = value => {
    const path = String(value || '').replace(/^\.\//, '').replace(/^\/assets\//, 'assets/');
    return window.HG_ASSETS?.[path] || value;
  };
  window.HGRoute = value => {
    const original = String(value || '');
    if (!original || /^(#|mailto:|tel:|data:|javascript:)/i.test(original)) return original;
    let url;
    try { url = new URL(original, base()); } catch (_) { return original; }
    if (url.origin !== new URL(base()).origin && !officialHosts.has(url.hostname)) return original;
    const file = url.pathname.split('/').pop();
    if (file?.endsWith('.html')) {
      const page = file.slice(0, -5);
      if (page === 'product') {
        const product = window.HG_DATA?.products.find(item => item.id === url.searchParams.get('id'));
        if (product?.url) {
          const target = new URL(product.url, base());
          url.searchParams.forEach((entry, key) => { if (key !== 'id' && key !== 'view') target.searchParams.set(key, entry); });
          target.hash = url.hash;
          return target.origin === new URL(base()).origin || officialHosts.has(target.hostname)
            ? target.pathname.replace(/^\/collections\/[^/]+\/products\//, '/products/') + target.search + target.hash
            : target.href;
        }
      }
      url.pathname = routes[page] || '/';
      if (!routes[page]) url.searchParams.set('view', 'hg-' + page);
      else url.searchParams.delete('view');
    }
    url.pathname = url.pathname.replace(/^\/collections\/[^/]+\/products\//, '/products/');
    return url.pathname + url.search + url.hash;
  };

  // Rewrite before DOM insertion: images never request an obsolete /assets URL.
  // This is deliberately local to HG markup, not an Element prototype override.
  window.HGMarkup = value => String(value).replace(/\b(href|src|srcset)=("|')([\s\S]*?)\2/g,
    (match, name, quote, raw) => {
      const decoded = raw.replace(/&amp;/g, '&').replace(/&quot;/g, '"').replace(/&#39;/g, "'");
      let resolved;
      if (name === 'href') resolved = window.HGRoute(decoded);
      else if (name === 'src') resolved = window.HGAsset(decoded);
      else resolved = decoded.split(',').map(part => {
        const [url, ...descriptor] = part.trim().split(/\s+/);
        return [window.HGAsset(url), ...descriptor].join(' ');
      }).join(', ');
      return name + '=' + quote + escapeAttribute(resolved) + quote;
    });

  window.HGPageForURL = href => {
    try {
      const url = new URL(href, base());
      if (url.origin !== new URL(base()).origin) return null;
      const view = url.searchParams.get('view');
      if (view?.startsWith('hg-')) return view.slice(3);
      const path = url.pathname.replace(/\/$/, '') || '/';
      if (path.startsWith('/products/')) return 'product';
      return Object.keys(routes).find(key => routes[key] === path) || null;
    } catch (_) { return null; }
  };
})();
